// Pictures for the expense categories.
//
// The person recording most petty spend may not read either language on the
// screen, so on the capture screen the picture is the control and the words are
// the caption. That only works if the pictures are obvious rather than clever:
// a cup for chai, a spanner for repairs, an auto for travel. Nothing abstract.
//
// Keyed off the category name so it works against databases seeded before
// categories carried an icon of their own; a category's stored `icon` wins when
// it has one.

const BY_KEYWORD: [RegExp, string][] = [
  [/pantry|refreshment|tea|chai|food|snack/i, '🍵'],
  [/repair|maintenance/i, '🔧'],
  [/travel|conveyance|taxi|auto|fuel/i, '🛺'],
  [/courier|postage|post/i, '📦'],
  [/supplies|stationery/i, '✏️'],
  [/electric|power/i, '💡'],
  [/rent|premises/i, '🏠'],
  [/internet|phone|telecom/i, '📶'],
  [/software|subscription/i, '💻'],
  [/production|shoot/i, '🎬'],
  [/freelance|contractor/i, '🧑‍💻'],
  [/media|ad spend|advertis/i, '📣'],
  [/salar|stipend|wage/i, '💰'],
  [/professional|statutory|legal|audit/i, '⚖️'],
  [/bank charge|bank fee/i, '🏦'],
  [/equipment|hardware|camera/i, '🎥'],
  [/variance|difference/i, '⚖️'],
];

export function categoryIcon(name: string, stored?: string | null): string {
  if (stored) return stored;
  for (const [re, icon] of BY_KEYWORD) if (re.test(name)) return icon;
  return '🧾';
}

/** A cash box and a bank account should not look alike when choosing one. */
export const accountIcon = (kind: string): string => (kind === 'cash' ? '💵' : '🏦');
